import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { hueVars, acquireMailto } from "../data/artists";
import ArtworkMedia from "./ArtworkMedia";

const EASE = [0.22, 1, 0.36, 1];

export default function PieceModal({ artist, onClose }) {
  const [viewIdx, setViewIdx] = useState(0);
  useEffect(() => {
    setViewIdx(0);
  }, [artist && artist.piece && artist.piece.title]);
  const activeView = artist && artist.piece && artist.piece.views ? artist.piece.views[viewIdx] : artist && artist.piece;
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {artist && (
        <motion.div
          id="modal-backdrop"
          data-testid="piece-modal"
          data-lenis-prevent
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          onClick={(e) => {
            if (e.target === e.currentTarget) onClose();
          }}
        >
          <motion.div
            className="modal"
            role="dialog"
            aria-modal="true"
            initial={{ opacity: 0, y: 38, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 26, scale: 0.98 }}
            transition={{ duration: 0.55, ease: EASE }}
          >
            <button className="modal-close" data-testid="modal-close-button" aria-label="Close" onClick={onClose}>
              ×
            </button>
            <div className="modal-visual">
              {activeView && (activeView.image || activeView.video) ? (
                <ArtworkMedia key={viewIdx} piece={activeView} alt={`${artist.piece.title} by ${artist.name}`} />
              ) : (
                <>
                  <div className="surface texture" style={hueVars(artist.hue)} />
                  <div className="foil" style={hueVars(artist.hue)} aria-hidden="true" />
                  <i className="tick tl" /><i className="tick tr" />
                  <span className="asset-tag">Awaiting artwork</span>
                </>
              )}
              {artist.piece.views && (
                <span className={`gw-focus-views modal-views${artist.piece.viewsDark ? " dark-text" : ""}`}>
                  {artist.piece.views.map((v, vi) => (
                    <button
                      key={v.label}
                      className={`gw-focus-view${vi === viewIdx ? " on" : ""}`}
                      data-testid={`piece-modal-view-${vi + 1}`}
                      onClick={() => setViewIdx(vi)}
                    >
                      {v.label}
                    </button>
                  ))}
                </span>
              )}
            </div>
            <div className="modal-body">
              <div className="artist-tag">{artist.name}</div>
              <h3 className="display">{activeView.title || artist.piece.title}</h3>
              <div className="price" data-testid="piece-price">{artist.piece.price}</div>
              <p className="desc">{artist.piece.desc}</p>
              <div className="spec-row"><span>Year</span><span>{artist.piece.year}</span></div>
              <div className="spec-row"><span>Edition</span><span>{artist.piece.edition}</span></div>
              <div className="spec-row"><span>Dimensions</span><span>{artist.piece.size}</span></div>
              <div className="spec-row"><span>Medium</span><span>{artist.piece.medium}</span></div>
              <a className="cta" data-testid="request-to-acquire-button" href={acquireMailto(artist)}>
                Request to Acquire
              </a>
              <p className="note">
                Opens your email app with a pre-filled enquiry. Enquiries are followed up personally; private viewings
                can be arranged by appointment.
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
